import { both, complement, equals, is } from 'ramda'

export const isValidNumber = both(is(Number), complement(equals(NaN)))

export const urlEncode = data => {
    let ret = []
    for (let i in data) {
        if (typeof data[i] !== 'undefined') {
            ret.push(encodeURIComponent(i) + '=' + encodeURIComponent(data[i]))
        }
    }
    return ret.join('&')
}

export const urlParams = (url, params) => {
    const delimiter = url.indexOf('?') === -1 ? '?' : '&'
    return `${url}${delimiter}${urlEncode(params)}`
}

export const identity = x => x

export const isJsonValid = str => {
    try {
        JSON.parse(str)
    } catch (e) {
        return false
    }
    return true
}

export const property = key => object => object[key]

export const getAccessToken = property('access_token')

export const getPermissions = auth => {
    const toObject = (object, key) => {
        object[key] = true
        return object
    }
    const token = getAccessToken(auth) ? getAccessToken(auth).split('.')[1] : null
    return token ? JSON.parse(window.atob(token)).authorities.reduce(toObject, {}) : {}
}




// WEBPACK FOOTER //
// ./src/utils/mainUtils.js